module.exports = __webpack_public_path__ + "img/asigUbi.58ebfa5e.png";